import React from 'react';

const FacebookTiles = ({ data, onTileClick }) => {
  // If no real data, don't show anything at all
  if (!data || (data.reach === 0 && data.impressions === 0 && data.engagement === 0 && data.followers === 0)) {
    return null; // Don't render anything
  }

  const tiles = [
    {
      id: 'analytics-overview',
      type: 'analytics',
      title: 'Vue d\'ensemble des Analytics',
      icon: '📊',
      data: {
        reach: data.reach || 0,
        impressions: data.impressions || 0,
        engagement: data.engagement || 0,
        followers: data.followers || 0,
        trend: data.trend || '+0%'
      },
      insights: [
        `Portée: ${data.reach || 0} personnes`,
        `Impressions: ${data.impressions || 0}`,
        `Taux d'engagement: ${data.engagement || 0}%`,
        `Abonnés: ${data.followers || 0}`
      ]
    },
    {
      id: 'recent-posts',
      type: 'feed',
      title: 'Publications Récentes',
      icon: '📝',
      data: {
        totalPosts: data.totalPosts || 0,
        avgEngagement: data.avgEngagement || 0,
        bestPost: data.bestPost || 'Aucune donnée',
        worstPost: data.worstPost || 'Aucune donnée'
      },
      insights: [
        `${data.totalPosts || 0} publications cette semaine`,
        `Engagement moyen: ${data.avgEngagement || 0}%`,
        `Meilleure publication: "${data.bestPost || 'Aucune donnée'}"`,
        `Publication la moins performante: "${data.worstPost || 'Aucune donnée'}"`
      ]
    },
    {
      id: 'audience-insights',
      type: 'audience',
      title: 'Insights Audience',
      icon: '👥',
      data: {
        ageGroups: data.ageGroups || {},
        gender: data.gender || {},
        topCities: data.topCities || [],
        interests: data.interests || []
      },
      insights: [
        `Audience principalement ${data.ageGroups?.primary || 'N/A'} ans (${data.ageGroups?.percentage || 0}%)`,
        `${data.gender?.female || 0}% de femmes, ${data.gender?.male || 0}% d'hommes`,
        `Top villes: ${data.topCities?.join(', ') || 'Aucune donnée'}`,
        `Intérêts: ${data.interests?.join(', ') || 'Aucune donnée'}`
      ]
    },
    {
      id: 'content-performance',
      type: 'content',
      title: 'Performance du Contenu',
      icon: '📈',
      data: {
        videos: data.videos || 0,
        images: data.images || 0,
        textPosts: data.textPosts || 0,
        avgVideoViews: data.avgVideoViews || 0,
        avgImageLikes: data.avgImageLikes || 0
      },
      insights: [
        `${data.videos || 0} vidéos publiées`,
        `${data.images || 0} images publiées`,
        `${data.textPosts || 0} publications texte`,
        `Moyenne vues vidéo: ${data.avgVideoViews || 0}`,
        `Moyenne likes images: ${data.avgImageLikes || 0}`
      ]
    },
    {
      id: 'engagement-trends',
      type: 'trends',
      title: 'Tendances d\'Engagement',
      icon: '📊',
      data: {
        peakHours: data.peakHours || [],
        bestDays: data.bestDays || [],
        engagementRate: data.engagementRate || 0,
        growth: data.growth || '+0%'
      },
      insights: [
        `Heures de pointe: ${data.peakHours?.join(', ') || 'Aucune donnée'}`,
        `Meilleurs jours: ${data.bestDays?.join(', ') || 'Aucune donnée'}`,
        `Taux d'engagement: ${data.engagementRate || 0}%`,
        `Croissance: ${data.growth || '+0%'} cette semaine`
      ]
    },
    {
      id: 'competitor-analysis',
      type: 'strategy',
      title: 'Analyse Concurrentielle',
      icon: '🏆',
      data: {
        competitors: data.competitors || [],
        yourPerformance: data.yourPerformance || {},
        competitorPerformance: data.competitorPerformance || {},
        marketPosition: data.marketPosition || 'N/A'
      },
      insights: [
        `Concurrents analysés: ${data.competitors?.length || 0}`,
        `Vos performances: ${data.yourPerformance?.followers || 0} abonnés`,
        `Performance concurrente: ${data.competitorPerformance?.followers || 0} abonnés`,
        `Position marché: ${data.marketPosition || 'N/A'}`
      ]
    }
  ];

  return (
    <div className="facebook-tiles-container">
      <div className="facebook-tiles-header">
        <h2>📊 Tableau de Bord Facebook</h2>
        <p>Analysez vos performances Facebook et obtenez des insights clés.</p>
      </div>
      <div className="facebook-tiles-grid">
        {tiles.map(tile => (
          <div key={tile.id} className="facebook-tile" onClick={() => onTileClick(tile)}>
            <div className="tile-header">
              <div className="tile-icon">{tile.icon}</div>
              <h3>{tile.title}</h3>
            </div>
            <div className="tile-content">
              <div className="tile-insights">
                {tile.insights.map((insight, i) => (
                  <div key={i} className="insight-item">
                    <span className="insight-bullet">•</span>
                    <p className="insight-text">{insight}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="tile-footer">
              <span className="tile-type">{tile.type}</span>
              <button className="tile-action-btn">
                Analyser avec IA →
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FacebookTiles;